<script setup>
import { computed } from 'vue'
import { Icon } from '@components'

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

const props = defineProps({
    title: {
        type: String,
    },
    icon: {
        type: String,
    },
    link: {
        type: String,
        default: ''
    }
})

const isPositionRight = computed(() => {
    return $settings.customizer.sidebar.content_position.includes('Right')
})
</script>

<style lang="scss" scoped></style>

<template>
    <router-link :to="{ name: props.link }" class="nav-item" :title="props.title" :class="[$settings.customizer.sidebar.show_background ? '!bg-white' : '!bg-[#F2F4F7]', isPositionRight ? 'ml-auto' : '']">
        <Icon size="12px" :name="props.icon" class="icon" />
        <div class="title">{{ props.title }}</div>
    </router-link>
</template>